<div
    class="alarm-window"
    [@fadeInOut]
    *ngIf="
        responsive.isXLarge() || responsive.isLarge();
        else alarmWindowSmaller
    "
    #alarmWindow
>
    <div class="alarm-window__header">
        <div data-cy="active-alarms-title" class="header__title">ACTIVE ALARMS</div>
    </div>
    <div>
        <ng-container *ngIf="alarms.slice(-4)">
            <ul
                class="alarm-window__contents"
                *ngFor="let alarmData of alarms.slice(-4).reverse()"
            >
                <li class="item item__img">
                    <app-alarm-status-icon
                        [statusText]="alarmData.level"
                    ></app-alarm-status-icon>
                </li>
                <li class="ellipsis__li">
                    <div data-cy="active-alarms-channel-name" class="ellipsis">
                        {{ alarmData.name }}
                    </div>
                </li>
                <li class="item item__time">
                    <div data-cy="active-alarms-time">
                        {{ alarmData.occurredAt | date: "HH:mm:ss" }}
                    </div>
                </li>
                <li class="item">
                    <div>
                        <button
                        data-cy="active-alarms-ack-button"
                            [disabled]="shouldDisableButton(alarmData)"
                            (click)="onClickAck(alarmData)"
                            class="primary"
                        >
                            ACK
                        </button>
                    </div>
                </li>
            </ul>
        </ng-container>
    </div>
    <div class="alarm-window__footer">
        <span data-cy="active-alarms-counter" class="total-alarms-text" [class.show]="alarms.length >= 5">
            {{ "alarm.window.total-alarms" | translate : { alarmNum: alarms.length } }}
        </span>
        <div class="more" (click)="clickShowMore()">
            <div data-cy="active-alarms-view-all-alarms-button" class="more__list">
                {{ "alarm.window.all-button" | translate }}
            </div>
        </div>
    </div>
</div>
<ng-template #alarmWindowSmaller>
    <div class="alarm-window-small container-width" #alarmWindow>
        <button
            class="previous-icon"
            (click)="onAlarmPrevious()"
            [disabled]="alarms.length === 0 || alarmIndex + 1 === alarms.length"
        >
            <mat-icon svgIcon="chevron"></mat-icon>
        </button>
        <div class="alarm-info" *ngIf="alarms.length > 0">
            <div class="content">
                <app-alarm-status-icon
                    [statusText]="alarms[alarmIndex].level"
                ></app-alarm-status-icon>
                <p>{{ alarms[alarmIndex].name }}</p>
                <span>{{
                    alarms[alarmIndex].occurredAt | date: "HH:mm:ss"
                }}</span>
            </div>
            <button
                [disabled]="shouldDisableButton(alarms[alarmIndex])"
                (click)="onClickAck(alarms[alarmIndex])"
                class="primary"
            >
                ACK
            </button>
        </div>
        <button
            class="next-icon"
            (click)="onAlarmNext()"
            [disabled]="alarms.length === 0 || alarmIndex === 0"
        >
            <mat-icon
                svgIcon="chevron"
                style="transform: rotate(90deg)"
            ></mat-icon>
        </button>
    </div>
</ng-template>
